module.exports = __webpack_public_path__ + "img/ic_quanbu@2x.c099d7a6.png";